// Sticky one-shot modifiers armed from the mobile key bar. SessionTerm.onData applies an armed
// Ctrl to the next input (a key-bar key or a character from the on-screen keyboard), then disarms.

const listeners = new Set<() => void>();

export const mods = { ctrl: false };

export function setCtrl(on: boolean) {
  if (mods.ctrl === on) return;
  mods.ctrl = on;
  listeners.forEach((l) => l());
}

export function subscribeMods(fn: () => void) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** Ctrl+<ch> as a C0 control character, or null when the key has no control form. */
export function ctrlOf(ch: string): string | null {
  const c = ch.charCodeAt(0);
  if (c >= 0x61 && c <= 0x7a) return String.fromCharCode(c - 0x60); // a-z
  if (c >= 0x40 && c <= 0x5f) return String.fromCharCode(c - 0x40); // @ A-Z [ \ ] ^ _
  switch (ch) {
    case ' ':
    case '`':
    case '2':
      return '\x00';
    case '|':
      return '\x1c';
    case '~':
    case '6':
      return '\x1e';
    case '-':
    case '/':
      return '\x1f';
    case '?':
      return '\x7f';
  }
  return null;
}

/** Apply an armed Ctrl to the first character of `d` and disarm. Cheap when nothing is armed. */
export function applyMods(d: string): string {
  if (!mods.ctrl) return d;
  setCtrl(false);
  const first = String.fromCodePoint(d.codePointAt(0)!);
  const c = ctrlOf(first);
  return c === null ? d : c + d.slice(first.length);
}
